import React from "react"
import PropTypes from "prop-types"
import Markdown from "markdown-to-jsx"
import CTAButton from "components/buttons/CTAButton"

const ActionGroup = ({ actions, ...rest }) => (
  <div
    css={[
      actions.length > 1 && {
        display: "inline-flex",
        flexDirection: "column",
      },
    ]}
  >
    {actions.map(({ _type, _key, ...actionProps }) => {
      actionProps.multi = actions.length > 1

      switch (_type) {
        case "ctaButton":
          return <ActionCTAButton key={_key} {...actionProps} {...rest} />
        case "ctaIconButton":
          return <ActionIconButton key={_key} {...actionProps} {...rest} />
        default:
          return null
      }
    })}
  </div>
)

const ActionCTAButton = ({ href, text, multi, ...props }) => (
  <CTAButton
    colorScheme="standard"
    size="md"
    href={href}
    css={[
      {
        "--shadowColor": "inherit",
      },
      multi && {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
      },
    ]}
    {...props}
  >
    {text}
  </CTAButton>
)

ActionCTAButton.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  multi: PropTypes.bool,
}

const ActionIconButton = ({ icon, ...rest }) => (
  <ActionCTAButton
    {...rest}
    icon={
      <Markdown css={{ path: { stroke: "currentColor" } }}>
        {icon.asset.svg.content}
      </Markdown>
    }
  />
)

ActionIconButton.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    asset: PropTypes.shape({
      svg: PropTypes.shape({
        content: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}

ActionGroup.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      // Simple Button
      PropTypes.shape(ActionCTAButton.propTypes),

      // Icon Button
      PropTypes.shape(ActionIconButton.propTypes),
    ])
  ),
}

export default ActionGroup
